<template>
    <div class="card mb-3">
        <div class="card-header bg-light">
            {{ isEnVersion ? model.nameEn : model.name}}
        </div>
        <div class="card-body">
            <h5 class="card-title">
                {{ criteriaType }}
            </h5>

            <div class="form-group row" v-if="isNumberCriteria || isNumberDateCriteria || isNumberYearCriteria">
                <label for="criteriaValue" class="col-sm-6 col-form-label">{{
                    $t('registers.events.evaluation.criteria.value')}}</label>
                <div class="col-sm-6">
                    <input type="text" readonly class="form-control-plaintext"
                           id="criteriaValue"
                           :value="model.decimalValue">
                </div>
            </div>

            <div class="form-group row" v-if="isNumberDateCriteria || isDateCriteria || isNumberYearCriteria">
                <label v-if="isNumberDateCriteria || isDateCriteria" for="criteriaValue"
                       class="col-sm-6 col-form-label">{{ $t('registers.events.evaluation.criteria.date')}}</label>
                <label v-else for="criteriaValue" class="col-sm-6 col-form-label">{{
                    $t('registers.events.evaluation.criteria.year')}}</label>
                <div class="col-sm-6">
                    <datetime-picker id="criteriaValue" v-model="model.datetimeValue" :readonly="true"
                                     :showOnlyYear="isNumberYearCriteria" :showTime="false"></datetime-picker>
                </div>
            </div>

            <div class="form-group row" v-if="isBooleanCriteria">
                <label for="criteriaValue" class="col-sm-6 col-form-label">{{
                    $t('registers.events.evaluation.criteria.value')}}</label>
                <div class="col-sm-6">
                    <span id="criteriaValue" class="form-control badge badge-secondary">{{ model.booleanValue ? $t('yes') : $t('no')}}</span>
                </div>
            </div>

            <div class="form-group row" v-if="isTextCriteria">
                <label for="criteriaValue" class="col-sm-6 col-form-label">{{
                    $t('registers.events.evaluation.criteria.value')}}</label>
                <div class="col-sm-6">
                    <input type="text" readonly class="form-control-plaintext"
                           id="criteriaValue"
                           :value="model.textValue">
                </div>
            </div>

            <div class="form-group row" v-if="isEvaluationCriteria">
                <label for="score" class="col-sm-6 col-form-label-lg">{{
                    $t('registers.events.evaluation.criteria.score')}}</label>
                <div class="col-sm-6">
                    <input type="text" readonly class="form-control-plaintext"
                           id="criteriaValue"
                           :value="model.score">
                </div>
            </div>

            <div class="card form-group" v-if="isPropertyCriteria">
                <div class="card-body">
                    <div class="form-group">
                        <label for="form-field" class="col-form-label">{{
                            $t('registers.events.evaluation.criteria.property')}}</label>
                        <input type="text" id="form-field" name="form-field" class="form-control" readonly
                               :value="model.formFieldName + ' / ' + model.formFieldCode"/>
                    </div>

                    <div class="form-group">
                        <label for="operator" class="col-form-label">{{
                            $t('registers.events.evaluation.criteria.operator')}}</label>
                        <input type="text" id="operator" name="operator" class="form-control" readonly
                               :value="model.operator"/>
                    </div>

                    <div v-if="isTextFormField" class="form-group">
                        <div class="form-group">
                            <label for="dropdown-value" class="col-form-label">{{
                                $t('registers.events.evaluation.criteria.value')}}</label>
                            <input type="text" id="dropdown-value" name="dropdown-value" class="form-control" readonly
                                   :value="model.textValue"/>
                        </div>
                    </div>
                    <div v-else-if="isDropdownFormField" class="form-group">
                        <div class="form-group">
                            <label for="dropdown-value" class="col-form-label">{{
                                $t('registers.events.evaluation.criteria.value')}}</label>
                            <input type="text" id="dropdown-value" name="dropdown-value" class="form-control" readonly
                                   :value="model.textValue"/>
                        </div>
                    </div>
                    <div v-else-if="isDatetimeFormField" class="form-group">
                        <span class="vs-select--label">{{ $t('registers.events.evaluation.criteria.date') }}</span>
                        <datetime-picker v-model="model.datetimeValue"
                                         :disabled="true"
                                         :showOnlyYear="false"
                                         :showTime="true">
                        </datetime-picker>
                    </div>
                    <div v-else-if="isToggleFormField" class="form-group">
                        <div>
                            <span
                                class=" vs-select--label">{{ $t('registers.events.evaluation.criteria.value') }}</span>
                        </div>
                        <div class="float-left mt-2">
                            <vs-checkbox v-model="model.booleanValue"
                                         :disabled="true">
                            </vs-checkbox>
                        </div>
                    </div>
                    <div v-else-if="isIntegerFormField || isDecimalFormField" class="form-group">
                        <vs-input type="number"
                                  :label="$t('registers.events.evaluation.criteria.value')"
                                  :disabled="true"
                                  v-model="model.decimalValue">
                        </vs-input>
                    </div>
                </div>
            </div>

            <!--<div class="form-group row">
        <label for="score" class="col-sm-6 col-form-label">{{ $t('registers.events.evaluation.criteria.additionallyAdded')}}</label>
        <div class="col-sm-6">
            <span class="badge"
                  :class="model.additionallyAdded ? 'badge-warning' : 'badge-secondary'">
                {{ model.additionallyAdded ? $t('yes') : $t('no') }}
            </span>
        </div>
    </div>-->
            <br/>
            <div class="form-group" v-if="!isLockedForEdit">
                <button type="button" class="btn btn-danger" @click="deleteCriteria">
                    <i class="far fa-trash-alt text-danger"></i>
                    {{ $t('buttons.delete.btnText')}}
                </button>
            </div>
        </div>
        <div class="card-footer">
            <div v-if="model.createdByUsername">
                <small class="text-muted">
                    {{ $t('registers.forms.gridHeaders.createdAtUtc') }} {{
                    this.$helpers.convertFromUtcToLocal(model.createdAtUtc).toLocaleString() }}
                </small>
                /
                <small class="text-muted">
                    {{ $t('registers.forms.gridHeaders.creatorUsername') }} "{{ model.createdByUsername }}"
                </small>
            </div>
        </div>
    </div>
</template>

<script>
    import {EvaluationCriteriaType} from '../../models/enums';
    import DatetimePicker from '../../components/datepicker/DatePicker';

    export default {
        props: {
            model: {
                type: Object,
                required: true
            },
            criteriaTypes: {
                type: Array
            },
            details: {
                type: Boolean,
                default: true
            },
            isLockedForEdit: {
                type: Boolean,
                default: false
            }
        },
        components: {
            DatetimePicker
        },
        data() {
            return {}
        },
        methods: {
            deleteCriteria() {
                this.$emit("delete", this.model);
            },
            convertFromUtcToLocal(value) {
                return this.$helpers.convertFromUtcToLocal(value);
            }
        },
        mounted() {

        },
        computed: {
            isEnVersion() {
                return this.$store.getters.currentCulture === 'en';
            },
            isAdmissibilityCriteria() {
                let val = parseInt(this.model.criteriaType);
                return !isNaN(val) && val === EvaluationCriteriaType.Admissibility;
            },
            isEvaluationCriteria() {
                let val = parseInt(this.model.criteriaType);
                return !isNaN(val) && val === EvaluationCriteriaType.Evaluation;
            },
            isNumberCriteria() {
                if (!this.model.code) {
                    return false;
                }

                let code = this.model.code.toLowerCase();
                return code && code.startsWith('n')
                    && code.startsWith('nd') === false;
            },
            isNumberDateCriteria() {
                if (!this.model.code) {
                    return false;
                }

                let code = this.model.code.toLowerCase();
                return code && code.startsWith('nd');
            },
            isNumberYearCriteria() {
                if (!this.model.code) {
                    return false;
                }

                let code = this.model.code.toLowerCase();
                return code && code.startsWith('ny');
            },
            isDateCriteria() {
                if (!this.model.code) {
                    return false;
                }

                let code = this.model.code.toLowerCase();
                return code && code.startsWith('d');
            },
            isBooleanCriteria() {
                if (!this.model.code) {
                    return false;
                }

                let code = this.model.code.toLowerCase();
                return code && code.startsWith('b');
            },
            isTextCriteria() {
                if (!this.model.code) {
                    return false;
                }

                let code = this.model.code.toLowerCase();
                return code && code.startsWith('s');
            },
            isPropertyCriteria() {
                if (!this.model.code) {
                    return false;
                }

                let code = this.model.code.toLowerCase();
                return code && code.startsWith('p');
            },
            criteriaType() {
                if (this.isEnVersion) {
                    for (var i = 0; i < this.criteriaTypes.length; i++) {
                        if (this.criteriaTypes[i].id === this.model.criteriaType) {
                            return this.criteriaTypes[i].textEn;
                        }
                    }
                } else {
                    for (var i = 0; i < this.criteriaTypes.length; i++) {
                        if (this.criteriaTypes[i].id === this.model.criteriaType) {
                            return this.criteriaTypes[i].text;
                        }
                    }
                }
            },
            isDatetimeFormField() {
                return this.model.fieldType.toLowerCase() === 'datepicker';
            },
            isToggleFormField() {
                return this.model.fieldType.toLowerCase() === 'toggle';
            },
            isDropdownFormField() {
                return this.model.fieldType.toLowerCase() === 'dropdown';
            },
            isIntegerFormField() {
                return this.model.fieldType.toLowerCase() === 'input'
                    && this.model.inputType.toLowerCase() === 'number'
                    && this.model.numberType.toLowerCase() === 'int';
            },
            isDecimalFormField() {
                return this.model.fieldType.toLowerCase() === 'input'
                    && this.model.inputType.toLowerCase() === 'number'
                    && this.model.numberType.toLowerCase() === 'decimal';
            },
            isTextFormField() {
                return this.model.fieldType.toLowerCase() === 'input'
                    && this.model.inputType.toLowerCase() === 'text';
            },
            formFieldFullName() {
                return `${this.model.formFieldName} / ${this.model.formFieldCode}`
            }
        }
    }
</script>
